<template>
  <div :style="{ height: `${lineheight}px` }" class="diaryRow">
    <div class="diaryBarHolder">
      <div
        :title="diaryEntry.diaryDate"
        :class="[
          'diaryComponent',
          'diaryBar',
          {
            'diaryComponent-clickable': canSelectDiaryEntry,
            moreLeft: left < 0,
            highlight: !!diaryEntry.highlightDate,
            unsigned: !diaryEntry.signedOff,
          },
        ]"
        :style="{ height: `${lineheight - 3}px`, lineHeight: `${lineheight - 3}px`, left: leftPos, width }"
        @click="selectThisDiary"
      >
        &nbsp;
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';

export default {
  name: 'Diary',
  data() {
    return {
      lock: false,
    };
  },
  props: ['filterDate', 'filterDateZoom', 'level', 'lineheight', 'lockedDragNDrop', 'diaryEntry'],
  watch: {
    filterDateZoom: function (newValue) {},
  },

  methods: {
    ...mapActions(['selectDiaryEntry']),

    selectThisDiary() {
      if (this.canSelectDiaryEntry) {
        this.selectDiaryEntry(this.diaryEntry.diaryDate);
      }
    },
  },

  computed: {
    ...mapGetters(['viewSettings', 'currentProject', 'hasSimplePermissions']),

    canSelectDiaryEntry() {
      return this.hasSimplePermissions('selectDiaryEntry');
    },

    leftPos: function () {
      var leftPos = this.left;
      if (leftPos < 0) {
        leftPos = 0;
      }
      return leftPos + 'px';
    },
    /**
     * lable start left side.
     */
    left: function () {
      var start = moment(this.diaryEntry.diaryDate);
      var first = moment(this.filterDate);
      var left =
        (this.filterDateZoom * this.viewSettings.projectPlan.zoomFactor * (start - first)) / (1000 * 60 * 60 * 24);

      return left;
    },
    /**
     * lable width.
     */
    width: function () {
      var calendarTime = 1;
      var left = this.left;
      var width = calendarTime * this.filterDateZoom * this.viewSettings.projectPlan.zoomFactor + Math.min(0, left);
      if (width < 10) {
        width = 10;
      }
      return width + 'px';
    },
  },
};
</script>

<style scoped>
.diary {
  background: white;
  text-align: left;

  position: relative;
  border: 1px solid grey;
}
.moreLeft {
  background-color: #eee;
  text-overflow: clip;
}
.moreLeft::before {
  content: '«';
}
.diaryComponent {
  white-space: nowrap;
  display: inline-block;
  position: absolute;
  margin: 0px;
  vertical-align: top;
}

.diaryComponent-clickable {
  cursor: pointer;
}

.diaryRow {
  position: absolute;
}

.diaryBarHolder {
  display: inline-block;
  position: absolute;
  overflow: visible;
  top: 0px;
}
.diaryBar {
  box-sizing: border-box;
  background: rgb(214, 125, 7);
  border: 1px solid rgb(214, 125, 7);
  border-radius: 2px;
  font-size: 10px;
  white-space: nowrap;
  margin-top: 1px;
  height: 17px;
}
.diaryBar.highlight {
  background: red;
}

.diaryBar.unsigned {
  background: grey;
}

.diaryBar span {
  margin-left: 5px;
  left: 100%;
  position: absolute;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/projectplan/DiaryPart.vue